import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { InbuiltDatasourceComponent } from './inbuilt-datasource/inbuilt-datasource.component';
import { RequireDatasourceContext } from './require-datasource-modal/require-datasource-modal.component';
import { VisualTypeOption } from './inbuilt-visual/inbuilt-visual.component';

@Component({
  selector: 'app-inbuilt-custom-report',
  standalone: false,
  templateUrl: './inbuilt-custom-report.component.html',
  styleUrl: './inbuilt-custom-report.component.scss'
})
export class InbuiltCustomReportComponent implements OnChanges {

  ngOnChanges(changes: SimpleChanges): void {
    this.hasDataSource = this.resolveHasDataSource();
  }

  // Datasource config is shared across every page/tab of the report - just check it has data.
  private resolveHasDataSource(): boolean {
    return !!this.dataSourceJson && Object.keys(this.dataSourceJson).length > 0;
  }
  /** Filters/visual cards stay in their disabled look until a data source is picked. */
  hasDataSource = false;
  datasourceConfig: any = null;
  requireDatasourceContext: RequireDatasourceContext = 'filter';
  showVisualMenu = false;
  selectedVisualMenuItem: VisualTypeOption | null = null;

  readonly visualTypeOptions: VisualTypeOption[] = [
    { type: 'table', label: 'Table', description: 'Configure data, width and formatting', icon: 'table_chart' },
    { type: 'bar_chart', label: 'Bar Chart', description: 'Configure data, width and formatting', icon: 'bar_chart' },
    { type: 'column_chart', label: 'Column Chart', description: 'Configure data, width and formatting', icon: 'insert_chart' },
    { type: 'kpi', label: 'KPI', description: 'Configure data, width and formatting', icon: 'insights' },
    { type: 'comparison_kpi', label: 'Comparison KPI', description: 'Configure data, width and formatting', icon: 'compare_arrows' },
    { type: 'metrics', label: 'Metrics', description: 'Configure data, width and formatting', icon: 'analytics' },
    { type: 'drill_down_matrix', label: 'DrillDown Metrics', description: 'Configure data, width and formatting', icon: 'grid_view' },
    { type: 'parent_child_table', label: 'Parent Child table', description: 'Configure data, width and formatting', icon: 'account_tree' },
    { type: 'donut_chart', label: 'Donut chart', description: 'Configure data, width and formatting', icon: 'donut_large' },
    { type: 'speedometer', label: 'Speedometer', description: 'Configure data, width and formatting', icon: 'speed' },
    { type: 'stack_chart', label: 'Stack chart', description: 'Configure data, width and formatting', icon: 'stacked_bar_chart' },
    { type: 'pie_chart', label: 'Pie chart', description: 'Configure data, width and formatting', icon: 'pie_chart' }
  ];

  @ViewChild('inbuiltDatasource') private inbuiltDatasource!: InbuiltDatasourceComponent;
  @ViewChild('requireDatasourceModal') private requireDatasourceModal: any;
  @ViewChild('addFilterModal') private addFilterModal: any;
  @ViewChild('addFilterModalBody') private addFilterModalBody: any;
  @ViewChild('addVisualModal') private addVisualModal: any;
  @ViewChild('addVisualModalBody') private addVisualModalBody: any;
  @Input() reportNameFromQueryParams!: string;
  @Input() dataSourceJson: any = {};
  // Lets the host (InbuiltReportV2Component) refetch the parent report JSON once the datasource is persisted.
  @Output() dataSourceSaved = new EventEmitter<void>();
  @Input() hasReportAdminRole:boolean = false;

  onSelectDataSource(payload: any): void {
    this.datasourceConfig = payload;
    this.hasDataSource = true;
    this.dataSourceSaved.emit();
  }

  onAddFilter(): void {
    if (!this.hasDataSource) {
      this.openRequireDatasourceModal('filter');
      return;
    }
    this.addFilterModal?.show();
  }

  onAddVisual(): void {
    if (!this.hasDataSource) {
      this.openRequireDatasourceModal('visual');
      return;
    }
    this.showVisualMenu = !this.showVisualMenu;
  }

  onSelectVisualType(option: VisualTypeOption): void {
    this.showVisualMenu = false;
    this.selectedVisualMenuItem = option;
    this.addVisualModalBody?.resetState();
    this.addVisualModal?.show();
  }

  onAddVisualCancelled(): void {
    this.addVisualModal?.hide();
  }

  onVisualCreated(_payload: any): void {
    // this.addVisualModal?.hide();
    // Hook up to the save-visual API once available.
  }

  onRequireDatasourceSelect(): void {
    this.requireDatasourceModal?.hide();
    this.inbuiltDatasource?.open();
  }

  onRequireDatasourceCancelled(): void {
    this.requireDatasourceModal?.hide();
  }

  onAddFilterCancelled(): void {
    this.addFilterModal?.hide();
  }

  onFilterCreated(_payload: any): void {
    this.addFilterModal?.hide();
    // Hook up to the save-filter API once available.
  }

  private openRequireDatasourceModal(context: RequireDatasourceContext): void {
    this.requireDatasourceContext = context;
    this.requireDatasourceModal?.show();
  }

}
